import { render } from "./QuizArea.vue?vue&type=template&id=535f42e4"
import script from "./QuizArea.vue?vue&type=script&lang=js"
export * from "./QuizArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__